module.exports = __webpack_public_path__ + "img/x6.045743c3.jpg";